import { createReducer, on } from '@ngrx/store';
import { CandidateDna } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';
import { DnaJobApplication } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-job-application.model';
import {
  loadCandidateDna,
  loadCandidateDnaApplications,
  loadCandidateDnaApplicationsError,
  loadCandidateDnaApplicationsSuccess,
  loadCandidateDnaError,
  loadCandidateDnaSuccess,
} from './candidate-dna.actions';

export interface CandidateDnaState {
  dna: CandidateDna | null;
  applications: DnaJobApplication[];
  loading: boolean;
  loaded: boolean;
}

const initialState: CandidateDnaState = {
  dna: null,
  applications: [],
  loading: false,
  loaded: false,
};

export const candidateDnaReducer = createReducer(
  initialState,
  on(loadCandidateDna, (state) => ({ ...state, loading: true })),
  on(loadCandidateDnaSuccess, (state, { dna }) => ({
    ...state,
    dna,
    loading: false,
    loaded: true,
  })),
  on(loadCandidateDnaError, (state) => ({ ...state, loading: false })),
  on(loadCandidateDnaApplications, (state) => ({ ...state, loading: true })),
  on(loadCandidateDnaApplicationsSuccess, (state, { applications }) => ({
    ...state,
    applications,
    loading: false,
    loaded: true,
  })),
  on(loadCandidateDnaApplicationsError, (state) => ({ ...state, loading: false })),
);
